import Util from "./util";

class Paths {
  /**
   *
   * @param {object} [props={}]
   */
  constructor(props = {}) {
    this.props = props;
    this.templates = {
      home: "/",
      leagueHome: "/leagues/:league",
      leagueSeasonHome: "/:league/:season/:week",
      leagueSeasonHomeNoWeek: "/:league/:season",
      teamHome: "/:league/:season/:team/:week",
      userHome: "/users/:username",
    };
    this.printLogs = false;
  }

  /**
   *
   * @param {string} propName
   * @param {object} [injectProps={}]
   * @returns {string}
   * @private
   */
  _get(propName, injectProps = {}) {
    const props = {
      ...this.props,
      ...injectProps,
    };

    if (props[propName]) {
      let prop = props[propName];
      return prop.slug || prop.id || prop;
    }

    return `:${propName}`;
  }

  /**
   *
   * @param {string} txt
   * @private
   */
  _log(txt) {
    if (this.printLogs) console.log(txt);
  }

  get(pathName, injectProps = {}) {
    this._log(`Paths.get() - called with ${pathName}`);

    let template = this.templates[pathName];
    this._log(`template: ${template}`);

    if (!template) throw new Error(`no template found for ${pathName}`);

    let pattern = /\/:([a-z]+)/gi;
    let matches = template.matchAll(pattern);
    let path = template;
    this._log("matches:");
    for (const match of matches) {
      let key = match[1];
      this._log(`key: ${key}`);

      let keyValue = this._get(key, injectProps);

      if (keyValue === ":week") {
        keyValue = Util.weekToUrl(Util.getCurrentWeek());
      }

      this._log(`keyValue: ${keyValue}`);
      this._log(`path before: ${path}`);

      let pattern = new RegExp(`:${key}/`);
      path = path.replace(pattern, keyValue + "/");
      this._log(`path after 1: ${path}`);

      pattern = new RegExp(`:${key}$`);
      path = path.replace(pattern, keyValue);
      this._log(`path after 2: ${path}`);
    }
    this._log(`final path: ${path}`);
    return path;
  }

  getTemplate(pathName) {
    return this.templates[pathName];
  }
}

export default Paths;
